// body types were taken from https://qa-21-www.edmunds.com/api/inventory/v5/aggregate?by=vehicleInfo.styleInfo.bodyType&top=20
export const BODY_TYPES = [
  'SUV',
  'Sedan',
  'Pickup',
  'Hatchback',
  'Coupe',
  'Minivan',
  'Convertible',
  'Station Wagon',
  'Full Size Van',
];
